import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import db from "../../../../../db"
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { Button } from '@material-ui/core';
import { toast } from 'react-toastify';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import { List } from "@material-ui/core";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: 80,
    width: "-webkit-fill-available"
  }
}));

const DataTable = props => {
  const { className, ...rest } = props;
  const [data, setData] = useState([])
  const [opChange, setOpChange] = useState(false);
  const [openL, setOpenL] = useState(false);
  const [name, setName] = useState()
  const [department, setDepartment] = useState()
  const [role, setRole] = useState()
  const [order, setOrder] = useState("կարդալ")
  const [bardzum, setBardzum] = useState("կարդալ")
  const [plan, setPlan] = useState("կարդալ")
  const [qr, setQR] = useState("կարդալ")
  const [warehouse, setWarehouse] = useState("կարդալ")
  const [report, setReport] = useState("կարդալ")
  const [info, setInfo] = useState("կարդալ")
  const [departmentData, setDepartmentData] = useState({})
  const [dashboard, setDashboard] = useState("կարդալ")
  const [acceptance, setAcceptance] = useState("ոչինչ")
  const [check, setCheck] = useState("ոչինչ")
  const [calcBalance, setCalcBalance] = useState("ոչինչ")
  const [packing, setPacking] = useState("ոչինչ")
  const [transferStorage, setTransferStorage] = useState("ոչինչ")
  const [scanning, setScanning] = useState("ոչինչ")
  const [balance, setBalance] = useState("ոչինչ")

  let [id, setId] = useState()


  useEffect(() => {
    db.ref('InfoCenter/Roles').on('value', snap => {
      if (snap.val()) {
        setData(snap.val())
      } else {
        setData([])
      }
    })
  }, [])

  const handleDelete = (keyId) => {
    db.ref('InfoCenter/Roles/' + keyId).remove().then(() => {
      toast.success('Հեռացված է')
    })
  }

  const handleEdit = (keyId) => {
    db.ref('InfoCenter/Departments').once('value').then(snap => {
      if (snap.val()) {
        setDepartmentData(snap.val())
      }
    })
    setId(keyId)
    setName(data[keyId].name)
    setRole(data[keyId].role)
    setDepartment(data[keyId].department)
    if (data[keyId].role == "BACKEND") {
      setOrder(data[keyId].order)
      setBardzum(data[keyId].bardzum)
      setPlan(data[keyId].plan)
      setQR(data[keyId].qr)
      setWarehouse(data[keyId].warehouse)
      setReport(data[keyId].report)
      setInfo(data[keyId].info)
      setDashboard(data[keyId].dashboard)
    } else if (data[keyId].role == "MOBILE/APP") {
      setAcceptance(data[keyId].acceptance)
      setCheck(data[keyId].check)
      setCalcBalance(data[keyId].calcBalance)
      setPacking(data[keyId].packing)
      setTransferStorage(data[keyId].transferStorage)
      setScanning(data[keyId].scanning)
      setBalance(data[keyId].balance)
    }
    setOpChange(true)




  }

  const handleSaveEdit = () => {
    if (!name || !department || !role) {
      toast.error('Լրացրեք բոլոր դաշտերը')
      return
    }
    if (name) {
      if (role == "BACKEND") {
        db.ref('InfoCenter/Roles/' + id).set({
          name: name,
          department: department,
          role: role,
          order: order,
          bardzum: bardzum,
          plan: plan,
          qr: qr,
          warehouse: warehouse,
          report: report,
          info: info,
          dashboard: dashboard
        }).then(() => {
          toast.success('Փոփոխված է')
          setOpChange(false)
          setName()
          setDepartment()
          setRole()
          setOrder("կարդալ")
          setBardzum("կարդալ")
          setPlan("կարդալ")
          setQR("կարդալ")
          setWarehouse("կարդալ")
          setReport("կարդալ")
          setInfo("կարդալ")
          setDashboard("Կարդալ")
        })
      } else if (role == "MOBILE/APP") {
        db.ref().child('InfoCenter/Roles/' + id).set({
          name: name,
          department: department,
          role: role,
          acceptance: acceptance,
          check: check,
          calcBalance: calcBalance,
          packing: packing,
          transferStorage: transferStorage,
          scanning: scanning,
          balance: balance
        }).then(() => {
          toast.success('Փոփոխված է');
          setName()
          setDepartment()
          setRole()
          setAcceptance("ոչինչ")
          setCheck("ոչինչ")
          setCalcBalance("ոչինչ")
          setPacking("ոչինչ")
          setTransferStorage("ոչինչ")
          setScanning("ոչինչ")
          setBalance("ոչինչ")
          setOpChange(false)
        })
      }

    }
    setId()
  }

  const handleClose = () => {
    setOpChange(false)
  }



  const classes = useStyles();

  return (

    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Իրավասության անվանում</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Ստորաբաժանում</TableCell>
                  <TableCell>Իրավասություններ</TableCell>
                  <TableCell>Գործողություն</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(data).map(i => (
                  < TableRow
                    className={classes.tableRow}
                    hover
                    key={i}
                  >
                    <TableCell>
                      {data[i].name}
                    </TableCell>
                    <TableCell>
                      {data[i].role}
                    </TableCell>
                    <TableCell>
                      {data[i].department}
                    </TableCell>
                    {data[i].role == "BACKEND" ?
                      <TableCell>
                        Dashboard - {data[i].dashboard} <br />
                      Պատվերներ - {data[i].order} <br />
                      Բարձումներ - {data[i].bardzum}<br />
                      Պլաններ - {data[i].plan}<br />
                      QR կոդերի բաժին - {data[i].qr}<br />
                      Պահեստ - {data[i].warehouse}<br />
                      Հաշվետվություններ - {data[i].report}<br />
                      Տեղեկատուներ - {data[i].info}
                      </TableCell> :
                      <TableCell>
                        Ընդունել - {data[i].acceptance} <br />
                      Ստուգել - {data[i].check} <br />
                      Հաշվարկ մնացորդ - {data[i].calcBalance}<br />
                      Փաթեթավորել - {data[i].packing}<br />
                      Հանձնել պահեստ - {data[i].transferStorage}<br />
                      Սկանավորում - {data[i].scanning}<br />
                      Մնացորդ - {data[i].balance}<br />
                      </TableCell>}
                    <TableCell>
                      <IconButton color="primary" onClick={() => handleEdit(i)} style={{ "padding": "0" }}>
                        <EditIcon />
                      </IconButton>
                      <IconButton color="primary" size="small" onClick={() => handleDelete(i)} >
                        <DeleteForeverIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <div>
        <Dialog open={opChange} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Փոփոխել իրավասություն</DialogTitle>
          <DialogContent>
            < TextField
              margin="dense"
              label="Իրավասության անվանում"
              type="text"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-label">Role</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <MenuItem value="BACKEND">BACKEND</MenuItem>
                <MenuItem value="MOBILE/APP">MOBILE/APP</MenuItem>
                <MenuItem value="DUAL">DUAL</MenuItem>
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-label">Ստորաբաժանում</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
              >
                {Object.keys(departmentData).map(el => (
                  <MenuItem key={el} value={departmentData[el].department}>{departmentData[el].department}</MenuItem>
                ))}


              </Select>
            </FormControl>


            <Button onClick={() => setOpenL(!openL)} style={{ "marginTop": "8px", "text-transform": "capitalize" }}>
              Իրավասություններ  {openL ? <ExpandLess /> : <ExpandMore />}
            </Button>
            {role == "BACKEND" && openL ? <List>
              <ListItem>
                <ListItemText primary="Պատվերներ" />
                <ListItemSecondaryAction>
                  <RadioGroup row aria-label="order" value={order} onChange={(e) => setOrder(e.target.value)}>
                    <FormControlLabel
                      value="ոչինչ"
                      control={<Radio />}
                      label="Ոչինչ"
                      labelPlacement="top"
                    />
                    <FormControlLabel
                      value="կարդալ"
                      control={<Radio />}
                      label="Կարդալ"
                      labelPlacement="top"
                    />
                    <FormControlLabel
                      value="խմբագրել"
                      control={<Radio />}
                      label="Խմբագրել"
                      labelPlacement="top"
                    />
                  </RadioGroup>
                </ListItemSecondaryAction>
              </ListItem>

              <ListItem>
                <ListItemText primary="Dashboard" />
                <ListItemSecondaryAction>
                  <RadioGroup row aria-label="gender" value={dashboard} onChange={(e) => setDashboard(e.target.value)}>
                    <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                    <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                    <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                  </RadioGroup>
                </ListItemSecondaryAction>
              </ListItem>

              <ListItem>
                <ListItemText primary="Բարձումներ" />
                <ListItemSecondaryAction>
                  <RadioGroup row aria-label="gender" value={bardzum} onChange={(e) => setBardzum(e.target.value)}>

                    <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                    <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                    <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                  </RadioGroup>
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem>
                <ListItemText primary="Պլաններ" />
                <ListItemSecondaryAction>
                  <RadioGroup row aria-label="gender" value={plan} onChange={(e) => setPlan(e.target.value)}>

                    <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                    <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                    <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                  </RadioGroup>
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem>
                <ListItemText primary="QR կոդերի բաժին" />
                <ListItemSecondaryAction>
                  <RadioGroup row aria-label="gender" value={qr} onChange={(e) => setQR(e.target.value)}>

                    <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                    <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                    <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                  </RadioGroup>
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem>
                <ListItemText primary="Պահեստ" />
                <ListItemSecondaryAction>
                  <RadioGroup row aria-label="gender" value={warehouse} onChange={(e) => setWarehouse(e.target.value)}>

                    <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                    <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                    <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                  </RadioGroup>
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem>
                <ListItemText primary="Հաշվետվություններ" />
                <ListItemSecondaryAction>
                  <RadioGroup row aria-label="gender" value={report} onChange={(e) => setReport(e.target.value)}>

                    <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                    <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                    <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                  </RadioGroup>
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem>
                <ListItemText primary="Տեղեկատուներ" />
                <ListItemSecondaryAction>
                  <RadioGroup row aria-label="gender" value={info} onChange={(e) => setInfo(e.target.value)}>

                    <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                    <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                    <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                  </RadioGroup>
                </ListItemSecondaryAction>
              </ListItem>
            </List> : <></>}
            {openL && role == "MOBILE/APP" ?
              <List>
                <ListItem>
                  <ListItemText primary="Ընդունել" />
                  <ListItemSecondaryAction>
                    <RadioGroup row aria-label="order" value={acceptance} onChange={(e) => setAcceptance(e.target.value)}>
                      <FormControlLabel
                        value="ոչինչ"
                        control={<Radio />}
                        label="Ոչինչ"
                        labelPlacement="top"
                      />
                      <FormControlLabel
                        value="կարդալ"
                        control={<Radio />}
                        label="Կարդալ"
                        labelPlacement="top"
                      />
                      <FormControlLabel
                        value="խմբագրել"
                        control={<Radio />}
                        label="Խմբագրել"
                        labelPlacement="top"
                      />
                    </RadioGroup>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                  <ListItemText primary="Ստուգել" />
                  <ListItemSecondaryAction>
                    <RadioGroup row aria-label="gender" value={check} onChange={(e) => setCheck(e.target.value)}>
                      <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                      <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                      <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                    </RadioGroup>
                  </ListItemSecondaryAction>
                </ListItem>

                <ListItem>
                  <ListItemText primary="Հաշվարկ Մնացորդ" />
                  <ListItemSecondaryAction>
                    <RadioGroup row aria-label="gender" value={calcBalance} onChange={(e) => setCalcBalance(e.target.value)}>
                      <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                      <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                      <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                    </RadioGroup>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                  <ListItemText primary="Փաթեթեավորել" />
                  <ListItemSecondaryAction>
                    <RadioGroup row aria-label="gender" value={packing} onChange={(e) => setPacking(e.target.value)}>
                      <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                      <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                      <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                    </RadioGroup>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                  <ListItemText primary="Հանձնել պահեստ" />
                  <ListItemSecondaryAction>
                    <RadioGroup row aria-label="gender" value={transferStorage} onChange={(e) => setTransferStorage(e.target.value)}>
                      <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                      <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                      <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                    </RadioGroup>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                  <ListItemText primary="Սկանավորում" />
                  <ListItemSecondaryAction>
                    <RadioGroup row aria-label="gender" value={scanning} onChange={(e) => setScanning(e.target.value)}>
                      <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                      <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                      <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                    </RadioGroup>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                  <ListItemText primary="Մնացորդ" />
                  <ListItemSecondaryAction>
                    <RadioGroup row aria-label="gender" value={balance} onChange={(e) => setBalance(e.target.value)}>
                      <FormControlLabel value="ոչինչ" control={<Radio />} style={{ "marginRight": "47px" }} />
                      <FormControlLabel value="կարդալ" control={<Radio />} style={{ "marginRight": "62px" }} />
                      <FormControlLabel value="խմբագրել" control={<Radio />} style={{ "marginRight": "26px" }} />
                    </RadioGroup>
                  </ListItemSecondaryAction>
                </ListItem>
              </List> : <></>}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Չեղարկել
          </Button>
            <Button onClick={handleSaveEdit} color="primary">
              Հաստատել
          </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Card>

  );
};

DataTable.propTypes = {
  className: PropTypes.string
};

export default DataTable;
